<script setup>
import {computed, watch} from 'vue'
import {useRoute} from 'vue-router'
import {useAppStore} from '@/stores/appStore'
import Listing from '@/common/listing/Listing'

const route = useRoute()
const appStore = useAppStore()

const tableName = computed(() => {
    const name = route.params.component

    switch (name) {
        case 'orders':
            return 'm_basket_orders'
        case 'order_items':
            return 'm_basket_orderitems'
        default:
            return name
    }
})

watch(tableName, (newName) => {
    if (newName) {
        appStore.navigationComponent = newName
    }
}, {immediate: true})
</script>

<template>
    <Listing :key="tableName" :table-name="tableName"/>
</template>